import React from 'react';
import Like from '@widget/post/Details/Components/Like';
import styles from './index.module.less';

export const PostLike = (props) => {
  const { isLoved, likeCount, like } = props;
  return (
    <div className={styles.container}>
      <Like type="2" curLikeCount={likeCount} isLoved={isLoved} likeFun={like} />
    </div>
  )
}
